import menuServices from "../api-service/menu-service";
import axios from "axios";
import Cookies from "js-cookie";
import { StateCreator } from "zustand";
import ProductModel from "../Models/PorductModel";
import StyleModel from "../Models/StyleModel";
import BranchModel from "../Models/BranchModel";
import MenuModel from "../Models/MenuModel";
import { CategoryModel } from "../Models/CategoryModel";
import RestaurantModel from "../Models/RestaurantModel";
import SocialMeidaModel from "../Models/SocialMeidaModel";

export interface MenuSlice {
  products: ProductModel[];
  product: ProductModel;
  restaurant: RestaurantModel;
  branches: BranchModel[];
  branch: BranchModel;
  menus: MenuModel[];
  categories: CategoryModel[];
  style: StyleModel;
  Menuloading: boolean;
  categoryLoading: boolean;
  itemLoading: boolean;
  branchesLoading: boolean;
  loading: boolean;
  social: SocialMeidaModel[];
  errorCode: string | number;
  image_offer: string;
  image_common: string;
  image_new: string;
  newProducts: ProductModel[];
  popularProducts: ProductModel[];
  priceOffersProducts: ProductModel[];
  searchProducts: ProductModel[];

  fetchBranchesAction: (payload: any) => Promise<any>;
  fetchMenusAction: (payload: any) => Promise<any>;
  fetchCategoriesAction: (payload: any) => Promise<any>;
  fetchProductsAction: (payload: any) => Promise<any>;
  getStyle: (payload: any) => Promise<any>;
  fetchProductByAction: (payload: any) => Promise<any>;
  selectProductAction: (item: ProductModel) => void;
  fetchPriceOffersProducts: (payload: any) => Promise<any>;
  fetchSearchProducts: (payload: any) => Promise<any>;
}
const getErrorCode = (error: unknown) => {
  if (axios.isAxiosError(error)) {
    return String(error.response?.status ?? error.code ?? "Unknown Error");
  }
  if (error instanceof Error) {
    return error.message;
  }
  return "Unknown Error";
};
export const createMenuSlice: StateCreator<MenuSlice, []> = (set) => ({
  branches: [],
  restaurant: {} as RestaurantModel,
  branch: {} as BranchModel,
  menus: [],
  categories: [],
  products: [],
  product: {} as ProductModel,
  social: [],
  style: {} as StyleModel,
  errorCode: "",
  image_offer: "",
  image_common: "",
  image_new: "",
  popularProducts: [],
  newProducts: [],
  priceOffersProducts: [],
  Menuloading: false,
  categoryLoading: false,
  itemLoading: false,
  branchesLoading: false,
  loading: false,
  searchProducts: [],

  fetchBranchesAction: async (payload: any) => {
    set({
      branchesLoading: true,
    });
    try {
      const res = await menuServices.getBranches(payload);
      set({
        branches: res.data.data.branch,
        social: res.data.data.social,
        restaurant: res.data.data.restaurant,
        style: res.data.data.style,
        branchesLoading: false,
      });
      return res.data.data;
    } catch (error) {
      set({ branchesLoading: false, errorCode: getErrorCode(error) });
    }
  },
  /////////////////////////////////////////////////////////
  fetchMenusAction: async (params: any) => {
    set({ loading: true });
    try {
      let paramsBranch = {};
      let visit = 0;

      if (!Cookies.get(`branch_${params.branch_id}`)) {
        const oneHourFromNow = new Date(new Date().getTime() + 60 * 60 * 1000);
        Cookies.set(`branch_${params.branch_id}`, "1", {
          expires: oneHourFromNow,
        });
        visit = 1;
        paramsBranch = {
          ...params,
          visit: visit,
        };
      } else {
        visit = 0;
        paramsBranch = { ...params, visit: visit };
      }
      const res = await menuServices.getMenu(paramsBranch);
      localStorage.setItem(
        `active_order${params.branch_id}`,
        res.data.data.branch.active_order
      );
      set({
        menus: res.data.data.menu,
        restaurant: res.data.data.restaurant,
        branch: res.data.data.branch,
        image_new: res.data.data.branch.image_new,
        image_common: res.data.data.branch.image_common,
        image_offer: res.data.data.branch.image_offer,
        social: res.data.data.social,
        style: res.data.data.style,
      });
      return res.data.data;
    } catch (error) {
      set({
        loading: false,
        errorCode: getErrorCode(error),
      });
    }
    return Promise.resolve(); // or return a promise from an API call
  },

  fetchCategoriesAction: async (params: any) => {
    set({ Menuloading: true });
    try {
      let visit = 0;
      if (!Cookies.get(`menu_${params.menu_id}`)) {
        const oneHourFromNow = new Date(new Date().getTime() + 60 * 60 * 1000);
        Cookies.set(`menu_${params.menu_id}`, "1", {
          expires: oneHourFromNow,
        });
        visit = 1;
      } else {
        visit = 0;
      }
      const res = await menuServices.getCategory({ ...params, visit: visit });
      set({
        categories: res.data.data,
        Menuloading: false,
      });
      return res.data.data;
    } catch (error) {
      set({
        Menuloading: false,
        errorCode: getErrorCode(error),
      });
    }
  },

  fetchProductsAction: async (params: any) => {
    set({ categoryLoading: true });
    try {
      let visit = 0;
      if (!Cookies.get(`category_${params.category_id}`)) {
        const oneHourFromNow = new Date(new Date().getTime() + 60 * 60 * 1000);
        Cookies.set(`category_${params.category_id}`, "1", {
          expires: oneHourFromNow,
        });
        visit = 1;
      } else {
        visit = 0;
      }
      const res = await menuServices.getProduct({ ...params, visit: visit });
      set({
        products: res.data.data,
        categoryLoading: false,
      });
      return res.data.data;
    } catch (error) {
      set({
        categoryLoading: false,
        errorCode: getErrorCode(error),
      });
    }
  },

  getStyle: async (params: any) => {
    try {
      const res = await menuServices.getStyle(params);
      set({
        style: res.data.data.style,
      });
      return res.data.data;
    } catch (error) {
      set({
        errorCode: getErrorCode(error),
      });
    }
  },

  fetchProductByAction: async ({ productId, domain }: any) => {
    set({ itemLoading: true });
    try {
      let visit = 0;
      if (!Cookies.get(`product_${productId}`)) {
        const oneHourFromNow = new Date(new Date().getTime() + 60 * 60 * 1000);
        Cookies.set(`product_${productId}`, "1", {
          expires: oneHourFromNow,
        });
        visit = 1;
      } else {
        visit = 0;
      }
      const res = await menuServices.getProductById({
        productId: productId,
        visit: visit,
        domain: domain,
      });
      set({
        product: res.data.data,
        itemLoading: false,
      });
      return res.data.data;
    } catch (error) {
      set({
        itemLoading: false,
        errorCode: getErrorCode(error),
      });
    }
  },

  selectProductAction: (item: ProductModel) => {
    set({ product: item });
  },
  ////////////////////////////////////////////////////////////////////////////
  //////////////////////////////////////////////////////////////////////////////
  ///////////////// products tags///////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////

  fetchPriceOffersProducts: async (params: any) => {
    set({ loading: true });
    try {
      const res = await menuServices.getProductPriceOffer(params);

      set((state) => {
        const newMenus: MenuModel[] = [];
        if (res.data.data.offer.length > 0) {
          newMenus.push({
            id: "offers",
            name_en: "Offers",
            name_ar: " العروض",
            image: res.data.data.image_offer
              ? res.data.data.image_offer
              : res.data.data.offer[0].image,
          });
        }

        if (res.data.data.new.length > 0) {
          newMenus.push({
            id: "new",
            name_en: "New",
            name_ar: " الجديد",
            image: res.data.data.image_new
              ? res.data.data.image_new
              : res.data.data.new[0].image,
          });
        }

        if (res.data.data.common.length > 0) {
          newMenus.push({
            id: "popular",
            name_en: "Popular",
            name_ar: " الأكثر شيوعاً",
            image: res.data.data.image_common
              ? res.data.data.image_common
              : res.data.data.common[0].image,
          });
        }

        return {
          ...state,
          priceOffersProducts: res.data.data.offer,
          newProducts: res.data.data.new,
          popularProducts: res.data.data.common,
          menus: [...newMenus, ...state.menus],
          loading: false,
        };
      });
      return res.data.data;
    } catch (error) {
      set({
        loading: false,
        errorCode: getErrorCode(error),
      });
    }
  },
  fetchSearchProducts: async (payload: any) => {
    try {
      const res = await menuServices.searchProduct(payload);
      set({
        searchProducts: res.data.data,
      });
      return res.data.data;
    } catch (error) {
      set({
        errorCode: getErrorCode(error),
      });
    }
  },
});
